// extracted by mini-css-extract-plugin
export default {"Root":"Banner_Root__l4D3b","Root-Caption":"Banner_Root-Caption__ewG2l","Credit":"Banner_Credit__E-nb3"};